const retry = (fn, retries = 5, delay = 500) => {
  let retriesLeft = retries;
  return new Promise(async (resolve, reject) => {
    let lastError;
    while (retriesLeft > 0) {
      try {
        await fn();
        return resolve();
      } catch (error) {
        lastError = error;
        retriesLeft--;
        if (retriesLeft > 0) {
          await new Promise((rs) => setTimeout(rs, delay));
        }
      }
    }
    // If we get here, all retries failed
    return reject(lastError);
  });
};

export default retry;
